/**
 * Copyright 2004-present Facebook. All Rights Reserved.
 *
 * @generated SignedSource<<5b51c5456d110a84ca16f27519f21b67>>
 *
 * Generated by LanguageCLDRGenScript
 *
 * 
 */
'use strict';

var IntlVariations = require("./IntlVariations");

var IntlCLDRNumberType38 = {
  getVariation: function getVariation(n) {
    if (n === 0 || n === 1) {
      return IntlVariations.NUMBER_ONE;
    } else {
      return IntlVariations.NUMBER_OTHER;
    }
  }
};
module.exports = IntlCLDRNumberType38;